const formatQuerySingleGEOFromId = id => {
  return `geo[0]=${id}`
}

const formatQueryInDifferentGEOs = (regionsData, offset = 0) => {
  let query = ''

  regionsData.forEach((regionData, index) => {
    if (index !== 0) {
      query += '&'
    }
    query += `geo[${offset + index}]=${regionData.id}`
  })

  return query
}

const formatQueryInSameGEO = regionsData => {
  let query = ''

  regionsData.forEach((regionData, index) => {
    if (index !== 0) {
      query += '&'
    }
    query += `geo[0]=${regionData.id}`
  })

  return query
}

const queryTools = {
  formatQuerySingleGEOFromId,
  formatQueryInDifferentGEOs,
  formatQueryInSameGEO
}

export default queryTools



// WEBPACK FOOTER //
// ./src/utils/queries/queryTools.js